import {
	promoIconSX,
	separatorSx,
	typoSX,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import { useRibbonURLs } from '@/data/Content/PromoIcons';
import { useLocalization } from '@/data/Localization';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, CardMedia, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

interface Props {
	name: string; // e.g., "PROMORIBBON_NXM_2BY1"
	nXm?: { baseQty: number; giftQty: number };
}

export const NxMPromo = ({ name, nXm }: Props) => {
	const urlRibbons = useRibbonURLs();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const { GetFreePieces, ForEach, InYourCart } = useLocalization('PromoIconsTxt');

	if (!nXm) return null;
	const imageUrl = urlRibbons[name];

	return (
		<>
			<Divider sx={separatorSx} />
			<Stack direction="row" alignItems={'center'}>
				<CardMedia
					image={imageUrl}
					sx={promoIconSX.nxm}
					title={name}
					component="img"
					className={setClassName(name)}
				/>
				<Box>
					<Typography variant="body1" component={isMobile ? 'p' : 'span'} sx={typoSX.firstRow}>
						{GetFreePieces.t({ baseQty: nXm.giftQty })}{' '}
					</Typography>
					<Typography variant="body1" sx={typoSX.secondRow} component={'span'}>
						{ForEach.t()}{' '}
					</Typography>
					<Typography variant="body1" sx={typoSX.secondRowBold} component={'span'}>
						{nXm.baseQty}{' '}
					</Typography>
					<Typography variant="body1" sx={typoSX.secondRow} component={'span'}>
						{InYourCart.t()}
						<sup>†</sup>
					</Typography>
				</Box>
			</Stack>
		</>
	);
};
